/**
 * Catalog lane for Party Search. Calls the deployed `searchCatalog` callable
 * through the existing Firebase client app. Does not hit Cloud Run URLs,
 * construct ID tokens, or search YouTube.
 */

import { httpsCallable } from 'firebase/functions';
import { ensureAnonymousAuth, functions } from '../firebase';
import { describeError } from '../utils/errorLog';

export const SEARCH_CATALOG_CALLABLE = 'searchCatalog';
export const SEARCH_CATALOG_LIMIT = 10;
export const SEARCH_UNAVAILABLE_MESSAGE = 'Search is temporarily unavailable. Try again.';

export function catalogSearchRequest(rawQuery) {
  return {
    contractVersion: 1,
    rawQuery: typeof rawQuery === 'string' ? rawQuery : '',
    limit: SEARCH_CATALOG_LIMIT,
    audience: 'event',
  };
}

function asCatalogResponse(payload) {
  const data = payload && typeof payload === 'object' ? payload : {};
  const results = Array.isArray(data.results) ? data.results : [];
  return {
    contractVersion: data.contractVersion === 1 ? 1 : data.contractVersion ?? 1,
    requestId: typeof data.requestId === 'string' ? data.requestId : '',
    confidenceClass: data.confidenceClass || null,
    results,
    nextCursor: data.nextCursor ?? null,
  };
}

export async function searchCatalog(rawQuery, { callable } = {}) {
  try {
    await ensureAnonymousAuth();
  } catch (error) {
    console.error('Catalog search auth failed:', describeError(error));
    return { ok: false, reason: 'unavailable' };
  }

  const invoke = callable || httpsCallable(functions, SEARCH_CATALOG_CALLABLE);
  try {
    const response = await invoke(catalogSearchRequest(rawQuery));
    return {
      ok: true,
      data: asCatalogResponse(response?.data),
    };
  } catch (error) {
    console.error('Catalog search failed:', describeError(error));
    return { ok: false, reason: 'unavailable' };
  }
}
